import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuBiopsyTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].biopsy) {
      return 'N/A';
    }

    if (key === 'noOfEmbryosBiopsied') {
      return data[index].biopsy.rows.length ?? 'N/A';
    }

    if (key === 'dnaDetected') {
      let count = 0;
      data[index].biopsy.rows.forEach((row) => {
        if (row.dnaDetected === 'Yes') {
          count++;
        }
      });
      return count;
    }

    if (key === 'noOfNormalEmbryos') {
      let count = 0;
      data[index].biopsy.rows.forEach((row) => {
        if (row.interpretation === 'Normal') {
          count++;
        }
      });
      return count;
    }

    if (data[index].biopsy[key] === null || data[index].biopsy[key] === '') {
      return 'N/A';
    }

    return data[index][key] ?? 'N/A';
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={3}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            EMBRYO BIOPSY DETAILS
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            No. of Embryos Biopsied
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>DNA Detetected</TableCell>
          <TableCell style={{ fontWeight: 700, ...borderRight }}>
            No. of Normal Embryos
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={3}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
        </TableRow>
        {data &&
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfEmbryosBiopsied', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('dnaDetected', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfNormalEmbryos', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuBiopsyTable;
